export class OwayoUser {
    constructor(userName, warenkorb) {
        this.derivedUserDataPath = "";
        this.userName = userName.replace("\\'", "'");
        this.email = "";
        this.telefon = "";
        this.ansprechpartner = "";
        this.warenkorb = warenkorb;
        this.adressen = [];
        this.loggedIn = false;
    }
}
export class KonfiUser extends OwayoUser {
    constructor(userName, warenkorb) {
        super(userName, warenkorb);
        this.entwuerfe = [];
    }
}
//# sourceMappingURL=OwayoUser.js.map